<!-- 
头顶轮转图
 -->
<template>
<div class="top-pic-list"  v-if="imglist.length > 1">
  <swiper ref="mySwiper" :options="swiperOptions">
    <swiper-slide v-for="(item, index) in imglist" :key="index" >
      <van-image
        height="6rem"
        :src="item"
        class="title ani"
        swiper-animate-effect="slideInRight" swiper-animate-duration="2s"
      />
    </swiper-slide>
  </swiper>
  <img src="https://assets.shmedia.tech/image/bs/toplogo.png" alt="back" class="bslogoback">
  <!-- <van-swipe @change="onChange" :autoplay="5000" imglist.length>
    <van-swipe-item v-for="(item, index) in imglist" :key="index">
      <van-image
        fit="cover"
        height="6rem"
        :src="item"
        class="vantitempic"
      />
    </van-swipe-item>
    <template #indicator>
      <div class="custom-indicator">
      </div>
    </template>
  </van-swipe> -->
  
</div>
</template>

<script>
// import * as swiperAni from './common/swiper.js'
export default {
  name: 'toppic',
  data() {
    return {
      current: 0,
      done: false,
      imglist: [],
      // contentid: document.getElementById("videoParam").getAttribute("contentId"),
      swiperOptions: {
        loop: true,
        autoplay: {
          disableOnInteraction: false,
          delay: 4000
        },
        effect: 'fade',
      }
    }
  },
  props:{
    view:{
      type: Object
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
    this.setMedia()
    // this.getView()
    // console.log(swiperAni)
  },
  methods: {
    setMedia() {
      const imglist = document.getElementById("Zoom").querySelectorAll("img")
      const list = []
      for(let item of imglist) {
        if(item.src) {
          list.push(item.src)
        }
      }
      this.imglist = list
      if(this.imglist.length == 0) {
        if(this.view.displayResources.length) {
          const list = []
          for(let item of this.view.displayResources) {
            if(item.sourceUrl) {
              list.push(item.sourceUrl)
            }
          }
          this.imglist = list
        }
      }
      console.log(this.imglist)
      // this.swiper.slideTo(3, 1000, false)
    },
    // 获取稿件详情
    getView(id) {
      const data = {
        id: id
      }
      this.post('/media-basic-port/api/app/news/content/get', data).then((response) => {
        // 如果code不为0，为稿件参数有误
        if(response.data.code == 0) {
          this.view = response.data.data || {}
          if(this.view.displayResources.length) {
            const list = []
            for(let item of this.view.displayResources) {
              if(item.sourceUrl) {
                list.push(item.sourceUrl)
              }
            }
            this.imglist = list
          }
          // actionUrl
        }
      }).catch(e =>{
        console.log(e)
      }).finally(() =>{

      })
    },
    onChange(index) {
      this.current = index;
    }
  }
}
</script>
<style>
@import 'https://assets.shmedia.tech/css/swiper.min.css';
  .panel {
    background: #fff;
  }
  .swiper-slide-active img{
    transition: all 3s;
  }
  .swiper-slide-active img {
    transform: scale(1.2); 
  }  
</style>
<style lang="less" scoped>
  // .top-pic-list {
  //   position: relative;
  // }
  .bslogoback {
    position: absolute;
    top: 3.2rem;
    z-index: 99;
  }
  /deep/.vantitempic img {
    height: 100%!important;
  }
  /deep/ .van-image__loading {
    display: none;
  }
</style>
